import { render, staticRenderFns } from "./MultiMonitorTag.vue?vue&type=template&id=7fe606a3"
import script from "./MultiMonitorTag.vue?vue&type=script&lang=js"
export * from "./MultiMonitorTag.vue?vue&type=script&lang=js"
import style0 from "./MultiMonitorTag.vue?vue&type=style&index=0&id=7fe606a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports